import { useTheme } from "@material-ui/core"
import * as React from "react"

function SchoolSvg(props) {
  const theme = useTheme();
  return (
    <svg
      id="schoolWarstwa_1"
      x={0}
      y={0}
      viewBox="0 0 42.5 40.4"
      xmlSpace="preserve"
      width="72" height="60"
      strokeWidth="1"
      {...props}
    >
      <style>
        {
          `.schoolst0{fill:none;stroke:${theme.palette.secondary.main};stroke-linejoin:round;stroke-miterlimit:10}`
        }
      </style>
      <path
        className="schoolst0"
        d="M10.8 7.9h20.9v15.9H10.8zM38.8 7.9h-2.7v15.9h2.7c1.8 0 3.2-1.4 3.2-3.2v-9.5c0-1.7-1.4-3.2-3.2-3.2zM6.4 7.9H3.7C1.9 7.9.5 9.3.5 11.1v9.5c0 1.8 1.4 3.2 3.2 3.2h2.7V7.9z"
      />
      <path
        className="schoolst0"
        d="M8.6 29.5c-1.2 0-2.2-1-2.2-2.2V7.9h4.4v19.3c0 1.3-1 2.3-2.2 2.3zM33.9 29.5c-1.2 0-2.2-1-2.2-2.2V7.9h4.4v19.3c0 1.3-1 2.3-2.2 2.3z"
      />
      <path
        className="schoolst0"
        d="M38.8 23.8h-2.7v3.4c0 1.2-1 2.2-2.2 2.2-1.2 0-2.2-1-2.2-2.2v-3.4H10.8v3.4c0 1.2-1 2.2-2.2 2.2-1.2 0-2.2-1-2.2-2.2v-3.4H3.7c-1.8 0-3.2-1.4-3.2-3.2v16.1c0 1.8 1.4 3.2 3.2 3.2h35.1c1.8 0 3.2-1.4 3.2-3.2V20.6c0 1.8-1.4 3.2-3.2 3.2zM21.3.5c-4.1 0-7.4 3.3-7.4 7.4h14.9C28.7 3.8 25.4.5 21.3.5z"
      />
    </svg>
  )
}

export default SchoolSvg
